<template>
  <div class="panel-container">
    <ul class="el-menu el-menu--collapse">
      <li class="el-submenu" v-for="widget in widgetComponent" :key="widget.name" :class="{ 'is-active': widget.name === currentActiveTable }" @click.prevent="showTab(widget.name)">
        <!-- <el-tooltip class="item" effect="dark" :content="i18nt(widget.label)" placement="right"> -->
        <div class="el-submenu__title">
          <svg-icon :icon-class="widget.icon" @click="showTab(widget.name)" />
        </div>
        <!-- </el-tooltip> -->
      </li>
    </ul>
    <div class="panel-widgets">
      <div v-for="(widget, index) in widgetComponent" :key="index">
        <component :is="widget.name" v-show="widget.name === currentActiveTable"></component>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/svg-icon';
import { formTemplates } from './templatesConfig';
import widgetComponents from './components/index.js';
import { useI18n } from '@/utils/i18n';
import { reactive, toRefs, ref, inject, provide, computed } from 'vue';

export default {
  components: {
    SvgIcon,
    ...widgetComponents,
  },
  name: 'FieldPanel',
  props: {
    designer: Object,
  },
  setup(props) {
    const { i18nt, i18n2t } = useI18n();
    const getDesignerConfig = inject('getDesignerConfig');

    provide('designer', props.designer);

    const data = reactive({
      activeTab: '',
      designerConfig: getDesignerConfig(),
      formTemplates: formTemplates,
      scrollerHeight: 0,
    });

    const widgetComponent = computed(() => {
      const comps = [];

      Object.keys(widgetComponents).forEach(key => {
        const item = widgetComponents[key];
        comps.push(item);
      });
      comps.sort((a, b) => {
        return a.sort - b.sort;
      });
      return comps;
    });

    const currentActiveTable = computed(() => {
      if (!data.activeTab) {
        return widgetComponent.value[0].name;
      } else {
        return data.activeTab;
      }
    });

    const showTab = name => {
      data.activeTab = name;
    };

    return {
      i18n2t,
      i18nt,
      ...toRefs(data),
      currentActiveTable,
      showTab,
      widgetComponent,
    };
  },
};
</script>

<style lang="scss" scoped>
.side-scroll-bar {
  height: 100%;
  :deep(.el-scrollbar__wrap) {
    overflow-x: hidden;
    margin-right: 0px !important;
  }
}

div.panel-container {
  display: flex;
  height: 100%;
}

div.panel-container :deep(ul.el-menu) {
  width: 50px !important;
  flex-shrink: 0;
  color: #909399;
  .el-submenu__title {
    padding: 0px;
    text-align: center;
  }

  .el-submenu {
    :hover {
      background-color: #ecf5ff;
    }
  }

  .is-active {
    background-color: #ecf5ff;

    .el-submenu__title {
      svg {
        color: #409eff;
      }
    }
  }
}

div.panel-container .panel-widgets {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.el-submenu__title {
  height: 56px;
  line-height: 56px;
  position: relative;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
}
</style>
